export default {
  title: 'Choose the plan',
  subtitle: '不限問卷建立數量與回覆上限！統計、調查、統計、分析輕鬆搞定',
  plan: {
    basic: {
      name: '標準版',
      subtitle: '現在註冊終身免費！',
      pricing: 'Free',
      currency: '',
      features: [
        '無限的問題數量',
        '無限的回覆數量',
        '精美範本',
        '基本題型',
        '歡迎頁面',
        '統計圖表',
        '資料匯出（PDF, CSV）',
        '多媒體',
        '問卷 QR code',
        'iframe 嵌入',
        '私密問卷',
        '題目編輯暫存區',
        '訪客紀錄',
        '投影片檢視模式',
        '公開結果連結',
        '問卷外觀設計',
        '置入答案至標題'
      ]
    },
    pro: {
      name: '專業版',
      subtitle: '更多更強大的問卷功能',
      pricing: '630',
      currency: 'NT$',
      features: [
        '感謝 Banner',
        '感謝頁轉址按鈕',
        '公開結果按鈕',
        '回收數量上限',
        '問卷有效日',
        '送出前預覽',
        '行銷追蹤碼設定',
        '預設值',
        '隱藏',
        '不重複',
        '計時',
        '批次貼上',
        '隨機排序',
        '邏輯跳題',
        '邏輯接題',
        '選項數量上限',
        '隱藏選項',
        '子母問卷',
        '篩選器',
        '合併分析與匯出',
        'SPSS 明細與匯出',
        '備註',
        '問卷網址產生器',
        'Email 自動通知',
        'Webhook',
        '自訂感謝頁'
      ]
    },
    team: {
      name: '團隊版',
      subtitle: '團隊協作，讓問卷效益最大化',
      pricing: '1,800',
      currency: 'NT$',
      features: ['多人協作', '把關答案品質 - 隔離區']
    },
    enterprise: {
      name: '企業版',
      subtitle: '專為企業打造的雲端問卷服務',
      pricing: '',
      currency: '',
      features: [
        '企業識別專屬問卷樣式與外觀',
        '專屬網域名稱',
        '專屬電話支援',
        '第三方資料串接與內部系統整合',
        '企業自建私有雲'
      ]
    }
  }
};
